module.exports = __webpack_public_path__ + "1529a2c1670b2c5f340eaac3db5c5080.svg";